import { AnyNotificationContext } from "../components/Notifications";

export const selectorPayerLogoFileIdFromContext = (
  context: AnyNotificationContext
): string | undefined => {
  if (!context) {
    return undefined;
  }

  if ("payer" in context && context.payer?.logoFileId) {
    return context.payer.logoFileId;
  }

  // TODO: fix after remove all of that on BE
  // @ts-ignore
  return context.client?.logoFileId;
};
